/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { type ReactNode } from "react";
import { ShieldAlert } from "lucide-react";
import { Button, type ButtonProps } from "./Button";
import { Tooltip } from "./Tooltip";

/** A button the viewer may see but not use: locked, it is disabled and says why on hover. */
export function GuardedButton({
  locked,
  hint,
  variant,
  size = "sm",
  ariaLabel,
  disabled = false,
  onClick,
  children,
}: {
  locked: boolean;
  hint: string;
  variant: NonNullable<ButtonProps["variant"]>;
  size?: "sm" | "md";
  ariaLabel?: string;
  disabled?: boolean;
  onClick: () => void;
  children: ReactNode;
}) {
  const button = (
    <Button
      variant={variant}
      size={size}
      disabled={locked || disabled}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {locked && <ShieldAlert size={15} />}
      {children}
    </Button>
  );
  if (!locked) {
    return button;
  }
  return (
    <Tooltip content={hint}>
      <span>{button}</span>
    </Tooltip>
  );
}
